import React, { useEffect, useState } from "react";
import { PieChart } from "@mui/x-charts/PieChart";
import { Box } from "@mui/material";
import { getCampaignsStatus } from "./dashboard-chart-section.utils";
import { seriesPayload } from "./dashboard-chart-section.constant";
import "./dashboard-chart-section.scss";

const MyCampaignsChartSection: any = (props: any) => {
  const { metricsData } = props;
  const [campaignsByStatus, setCampaignsByStatus] = useState<any>([]);

  const LegendItem = (propss: any) => {
    const { color, label } = propss;
    return (
      <Box display="flex" alignItems="center" mb={1}>
        <svg
          width="15"
          height="15"
          viewBox="0 0 9 9"
          fill="none"
          style={{ marginRight: 8 }}
        >
          <circle cx="4.5" cy="4.5" r="4" fill={color} />
        </svg>
        <span>{label}</span>
      </Box>
    );
  };

  useEffect(() => {
    setTimeout(() => {
      setCampaignsByStatus(
        getCampaignsStatus(metricsData?.campaignsByStatus) || []
      );
    }, 100);
  }, [metricsData]);

  return (
    <div className="dashboard-chart-section">
      <div className="dashboard-chart-section-cards">
        <div className="dashboard-chart-section-cards-chart">
          <div className="pie-chart-wrapper">
            <PieChart
              series={[
                {
                  ...seriesPayload,
                  data: campaignsByStatus,
                  sortingValues: "desc",
                  valueFormatter: () => {
                    return ``;
                  },
                },
              ]}
              height={160}
              width={160}
              legend={{
                hidden: true,
                position: {
                  vertical: "middle",
                  horizontal: "right",
                },
                direction: "column",
                itemMarkWidth: 10,
                itemGap: 3,
                markGap: 10,
                labelStyle: {
                  fontSize: 15,
                },
              }}
              margin={{
                bottom: 0,
                left: 0,
                right: 0,
                top: 0,
              }}
            />
          </div>
          <div className="legend-wrapper">
            {campaignsByStatus?.map((item: any) => (
              <LegendItem key={item.id} color={item.color} label={item.label} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
export default MyCampaignsChartSection;
